export enum Permission {
  Shifts = 'shifts',
  ManageShoppers = 'manage_shoppers.legacy_permission',
}
